import OnMountIsLoadedMixin from '@/mixins/on-mount-is-loaded';
import { Component } from 'vue-property-decorator';

@Component
export default class TypingIndicatorMessage extends OnMountIsLoadedMixin {}
